import React, { useMemo } from "react";
import { Group, Text } from "react-konva";
import { FONT_SIZE, FONT_FAMILY } from "../../consts";
import { measureTextWidth } from "../../text-utils";
import Hoverable from "frontend/ui-components/konva-helpers/hoverable";
import tracking from "frontend/tracking";

const SHOW_MORE_COLOR = "#1973FF";

interface ShowMoreButtonProps {
  x: number;
  y: number;
  showAllUpdates: boolean;
  onToggle: (e: { evt: Event }) => void;
}

export const ShowMoreButton = React.memo(({ x, y, showAllUpdates, onToggle }: ShowMoreButtonProps) => {
  const text = showAllUpdates ? "Show less" : "Show more";
  const HIT_AREA_PADDING = 3;

  const textWidth = useMemo(() => {
    const { width } = measureTextWidth(text, {
      fontSize: FONT_SIZE,
      fontFamily: FONT_FAMILY,
    });
    return width;
  }, [text]);

  const textHeight = FONT_SIZE;

  const handleToggleUpdates = (e: never) => {
    tracking.trackAnalyticsEvent("monday_task_updates_visibility_changed", {
      action: showAllUpdates ? "collapse" : "expand",
    });
    onToggle(e);
  };

  return (
    <Group x={x} y={y}>
      {/* Invisible hit area rect */}
      <Hoverable
        x={-HIT_AREA_PADDING}
        y={-HIT_AREA_PADDING}
        width={textWidth + HIT_AREA_PADDING * 2}
        height={textHeight + HIT_AREA_PADDING * 2}
        fill="transparent"
        cursor="pointer"
        onClick={handleToggleUpdates}
        listening
      />
      <Text
        text={text}
        fill={SHOW_MORE_COLOR}
        fontFamily={FONT_FAMILY}
        fontSize={FONT_SIZE}
        letterSpacing={0.1737}
        listening={false}
        width={70}
        align="right"
      />
    </Group>
  );
});

ShowMoreButton.displayName = "ShowMoreButton";
